import { Component, Prop, Mixins } from 'vue-property-decorator';
import FieldMixin from '@/mixins/registration/FieldMixin';

@Component
export default class FormFieldMixin extends Mixins(FieldMixin) {
  @Prop() readonly fieldName!: string;
  @Prop() readonly label!: string;
  @Prop() readonly placeholder!: string;
  @Prop() readonly helpText!: string;
  @Prop() readonly requiredMessage!: string;
  @Prop({ default: false }) readonly required!: boolean;

  public fieldRequired (): boolean {
    if (this.fieldName !== undefined) {
      return this.isRequired(this.fieldName) || this.required;
    } else {
      return this.required;
    }
  }

  public fieldHidden (): boolean {
    if (this.fieldName !== undefined) {
      return this.isHidden(this.fieldName);
    }
    return false;
  }

  public getHelpText (): string | undefined {
    if (this.fieldName !== undefined) {
      const customHelpText = this.getCustomHelpText(this.fieldName) || this.helpText;
      return customHelpText;
    } else {
      return this.helpText;
    }
  }

  public getLabel (): string | undefined {
    if (this.fieldName !== undefined) {
      const customLabel = this.getCustomLabel(this.fieldName) || this.label;
      return customLabel;
    } else {
      return this.label;
    }
  }

  public getLabelTooltip () {
    const label = this.getLabel();
    if (label && label.length > 30) {
      return {
        content: this.getLabel(),
        classes: 'v-tooltip',
        placement: 'top-start',
        container: 'body',
        trigger: 'hover click'
      };
    }
    return undefined;
  }

  public hasHelpText (): boolean {
    const helpText = this.getHelpText();
    return helpText !== '' && helpText !== undefined && helpText !== null;
  }

  public hasLabel (): boolean {
    const label = this.getLabel();
    return label !== '' && label !== undefined && label !== null;
  }

  public hasPlaceholder (): boolean {
    return this.placeholder !== '' && this.placeholder !== undefined && this.placeholder !== null;
  }

  public getTooltipFromText (text: string) {
    if (text && text.length > 30) {
      return {
        content: `<span>${text}${(this.fieldRequired() ? '<span style="color: #d00;">&nbsp;*</span>' : '')}</span>`,
        classes: 'v-tooltip',
        placement: 'top-start',
        container: 'body',
        trigger: 'hover click',
        html: true
      };
    }
    return undefined;
  }
}
